@let view = view$ | async;

@if (view === ScreenType.mobile && screens.includes(ScreenType.mobile) ||
  view === ScreenType.tablet && screens.includes(ScreenType.tablet) ||
  view === ScreenType.desktop && screens.includes(ScreenType.desktop)
) {
  <ng-content />
}
